import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  padding: 50px 0;
  display: flex;
  flex-direction: row;

  table {
    a {
      color: #063077;
      text-decoration: underline;
    }

    width: 90%;
    margin: 10px auto;

    th,
    tr,
    td {
      text-align: center;
      font-weight: bold;
    }

    button {
      font-weight: bold;
      border: none;
      margin: 10px;
      background-color: #ce1720;
      border-radius: 10px;
      padding-top: 5px;
      padding-bottom: 5px;
      padding-left: 10px;
      padding-right: 10px;
      color: #fff;
    }
  }

  .vendor-profile-left-block {
    background: #f9f9f9;
    border: 2px solid gray;
    border-radius: 10px;
    margin-right: 50px;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .profile-img-wrapper {
      border: 2px solid gray;
      border-radius: 50%;
      padding: 10px;
    }

    img {
      width: 300px;
      height: 300px;
      border-radius: 50%;
    }
  }

  .vendor-profile-right-block {
    flex: 1;
  }

  .vendor-profile-right-top {
    margin-bottom: 50px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }
  .vendor-profile-right-top-l {
    border: 2px solid gray;
    border-radius: 10px;
    margin-right: 50px;
    flex: 0.55;
  }
  .vendor-profile-right-top-r {
    border: 2px solid gray;
    border-radius: 10px;
    flex: 0.45;
  }

  .vendor-profile-right-bot {
    border: 2px solid gray;
    border-radius: 10px;
  }
`;
